<script setup lang="ts">
import { computed } from 'vue';
import { useCalendarStore } from '@/store';

const hours = computed(() => {
  const totals = useCalendarStore().documentedHours;

  return totals ? `${totals.documented}/${totals.planned}` : '0';
});
</script>

<template>
  <div class="flex flex-column">
    <label>Documented</label>
    <div class="hours font-bold align-items-center" v-text="hours" />
  </div>
</template>

<style scoped lang="scss">
label {
  line-height: 12px;
  font-size: 10px;
  color: $grayDark;
}
.hours {
  line-height: 18px;
  color: var(--primary-color-dark);
  font-size: 14px;
}
</style>
